import aeFlag from '@/assets/images/flags/ae.svg';
import afFlag from '@/assets/images/flags/af.svg';
import alFlag from '@/assets/images/flags/al.svg';
import amFlag from '@/assets/images/flags/am.svg';
import aoFlag from '@/assets/images/flags/ao.svg';
import arFlag from '@/assets/images/flags/ar.svg';
import auFlag from '@/assets/images/flags/au.svg';
import awFlag from '@/assets/images/flags/aw.svg';
import azFlag from '@/assets/images/flags/az.svg';
import baFlag from '@/assets/images/flags/ba.svg';
import bbFlag from '@/assets/images/flags/bb.svg';
import bdFlag from '@/assets/images/flags/bd.svg';
import bgFlag from '@/assets/images/flags/bg.svg';
import bhFlag from '@/assets/images/flags/bh.svg';
import biFlag from '@/assets/images/flags/bi.svg';
import bmFlag from '@/assets/images/flags/bm.svg';
import bnFlag from '@/assets/images/flags/bn.svg';
import boFlag from '@/assets/images/flags/bo.svg';
import brFlag from '@/assets/images/flags/br.svg';
import bsFlag from '@/assets/images/flags/bs.svg';
import btFlag from '@/assets/images/flags/bt.svg';
import bwFlag from '@/assets/images/flags/bw.svg';
import byFlag from '@/assets/images/flags/by.svg';
import bzFlag from '@/assets/images/flags/bz.svg';
import caFlag from '@/assets/images/flags/ca.svg';
import cdFlag from '@/assets/images/flags/cd.svg';
import cfFlag from '@/assets/images/flags/cf.svg';
import ciFlag from '@/assets/images/flags/ci.svg';
import clFlag from '@/assets/images/flags/cl.svg';
import cnFlag from '@/assets/images/flags/cn.svg';
import coFlag from '@/assets/images/flags/co.svg';
import crFlag from '@/assets/images/flags/cr.svg';
import cuFlag from '@/assets/images/flags/cu.svg';
import cvFlag from '@/assets/images/flags/cv.svg';
import czFlag from '@/assets/images/flags/cz.svg';
import djFlag from '@/assets/images/flags/dj.svg';
import dkFlag from '@/assets/images/flags/dk.svg';
import dmFlag from '@/assets/images/flags/dm.svg';
import doFlag from '@/assets/images/flags/do.svg';
import dzFlag from '@/assets/images/flags/dz.svg';
import egFlag from '@/assets/images/flags/eg.svg';
import ehFlag from '@/assets/images/flags/eh.svg';
import erFlag from '@/assets/images/flags/er.svg';
import etFlag from '@/assets/images/flags/et.svg';
import europeanUnFlag from '@/assets/images/flags/european_union.svg';
import fjFlag from '@/assets/images/flags/fj.svg';
import fkFlag from '@/assets/images/flags/fk.svg';
import gbFlag from '@/assets/images/flags/gb.svg';
import geFlag from '@/assets/images/flags/ge.svg';
import ghFlag from '@/assets/images/flags/gh.svg';
import giFlag from '@/assets/images/flags/gi.svg';
import gmFlag from '@/assets/images/flags/gm.svg';
import gnFlag from '@/assets/images/flags/gn.svg';
import gpFlag from '@/assets/images/flags/gp.svg';
import gtFlag from '@/assets/images/flags/gt.svg';
import gyFlag from '@/assets/images/flags/gy.svg';
import hkFlag from '@/assets/images/flags/hk.svg';
import hnFlag from '@/assets/images/flags/hn.svg';
import hrFlag from '@/assets/images/flags/hr.svg';
import htFlag from '@/assets/images/flags/ht.svg';
import huFlag from '@/assets/images/flags/hu.svg';
import idFlag from '@/assets/images/flags/id.svg';
import ilFlag from '@/assets/images/flags/il.svg';
import imFlag from '@/assets/images/flags/im.svg';
import iqFlag from '@/assets/images/flags/iq.svg';
import irFlag from '@/assets/images/flags/ir.svg';
import isFlag from '@/assets/images/flags/is.svg';
import jeFlag from '@/assets/images/flags/je.svg';
import jmFlag from '@/assets/images/flags/jm.svg';
import joFlag from '@/assets/images/flags/jo.svg';
import jpFlag from '@/assets/images/flags/jp.svg';
import keFlag from '@/assets/images/flags/ke.svg';
import kgFlag from '@/assets/images/flags/kg.svg';
import khFlag from '@/assets/images/flags/kh.svg';
import kmFlag from '@/assets/images/flags/km.svg';
import kpFlag from '@/assets/images/flags/kp.svg';
import krFlag from '@/assets/images/flags/kr.svg';
import kwFlag from '@/assets/images/flags/kw.svg';
import kyFlag from '@/assets/images/flags/ky.svg';
import kzFlag from '@/assets/images/flags/kz.svg';
import laFlag from '@/assets/images/flags/la.svg';
import lbFlag from '@/assets/images/flags/lb.svg';
import liFlag from '@/assets/images/flags/li.svg';
import lkFlag from '@/assets/images/flags/lk.svg';
import lrFlag from '@/assets/images/flags/lr.svg';
import lsFlag from '@/assets/images/flags/ls.svg';
import ltFlag from '@/assets/images/flags/lt.svg';
import lvFlag from '@/assets/images/flags/lv.svg';
import lyFlag from '@/assets/images/flags/ly.svg';
import mdFlag from '@/assets/images/flags/md.svg';
import mgFlag from '@/assets/images/flags/mg.svg';
import mkFlag from '@/assets/images/flags/mk.svg';
import mmFlag from '@/assets/images/flags/mm.svg';
import mnFlag from '@/assets/images/flags/mn.svg';
import moFlag from '@/assets/images/flags/mo.svg';
import mrFlag from '@/assets/images/flags/mr.svg';
import muFlag from '@/assets/images/flags/mu.svg';
import mvFlag from '@/assets/images/flags/mv.svg';
import mwFlag from '@/assets/images/flags/mw.svg';
import mxFlag from '@/assets/images/flags/mx.svg';
import myFlag from '@/assets/images/flags/my.svg';
import mzFlag from '@/assets/images/flags/mz.svg';
import naFlag from '@/assets/images/flags/na.svg';
import ngFlag from '@/assets/images/flags/ng.svg';
import niFlag from '@/assets/images/flags/ni.svg';
import noFlag from '@/assets/images/flags/no.svg';
import npFlag from '@/assets/images/flags/np.svg';
import nzFlag from '@/assets/images/flags/nz.svg';
import omFlag from '@/assets/images/flags/om.svg';
import paFlag from '@/assets/images/flags/pa.svg';
import peFlag from '@/assets/images/flags/pe.svg';
import pgFlag from '@/assets/images/flags/pg.svg';
import phFlag from '@/assets/images/flags/ph.svg';
import pkFlag from '@/assets/images/flags/pk.svg';
import plFlag from '@/assets/images/flags/pl.svg';
import pyFlag from '@/assets/images/flags/py.svg';
import qaFlag from '@/assets/images/flags/qa.svg';
import roFlag from '@/assets/images/flags/ro.svg';
import rsFlag from '@/assets/images/flags/rs.svg';
import ruFlag from '@/assets/images/flags/ru.svg';
import rwFlag from '@/assets/images/flags/rw.svg';
import saFlag from '@/assets/images/flags/sa.svg';
import sbFlag from '@/assets/images/flags/sb.svg';
import scFlag from '@/assets/images/flags/sc.svg';
import sdFlag from '@/assets/images/flags/sd.svg';
import seFlag from '@/assets/images/flags/se.svg';
import sgFlag from '@/assets/images/flags/sg.svg';
import slFlag from '@/assets/images/flags/sl.svg';
import soFlag from '@/assets/images/flags/so.svg';
import srFlag from '@/assets/images/flags/sr.svg';
import stFlag from '@/assets/images/flags/st.svg';
import svFlag from '@/assets/images/flags/sv.svg';
import sxFlag from '@/assets/images/flags/sx.svg';
import syFlag from '@/assets/images/flags/sy.svg';
import szFlag from '@/assets/images/flags/sz.svg';
import thFlag from '@/assets/images/flags/th.svg';
import tjFlag from '@/assets/images/flags/tj.svg';
import tmFlag from '@/assets/images/flags/tm.svg';
import tnFlag from '@/assets/images/flags/tn.svg';
import toFlag from '@/assets/images/flags/to.svg';
import trFlag from '@/assets/images/flags/tr.svg';
import ttFlag from '@/assets/images/flags/tt.svg';
import twFlag from '@/assets/images/flags/tw.svg';
import tzFlag from '@/assets/images/flags/tz.svg';
import uaFlag from '@/assets/images/flags/ua.svg';
import ugFlag from '@/assets/images/flags/ug.svg';
import usFlag from '@/assets/images/flags/us.svg';
import uyFlag from '@/assets/images/flags/uy.svg';
import uzFlag from '@/assets/images/flags/uz.svg';
import veFlag from '@/assets/images/flags/ve.svg';
import vnFlag from '@/assets/images/flags/vn.svg';
import vuFlag from '@/assets/images/flags/vu.svg';
import wfFlag from '@/assets/images/flags/wf.svg';
import wsFlag from '@/assets/images/flags/ws.svg';
import yeFlag from '@/assets/images/flags/ye.svg';
import zaFlag from '@/assets/images/flags/za.svg';
import zmFlag from '@/assets/images/flags/zm.svg';
import zwFlag from '@/assets/images/flags/zw.svg';
export default {
  aeFlag: aeFlag,
  afFlag: afFlag,
  alFlag: alFlag,
  amFlag: amFlag,
  aoFlag: aoFlag,
  arFlag: arFlag,
  auFlag: auFlag,
  awFlag: awFlag,
  azFlag: azFlag,
  baFlag: baFlag,
  bbFlag: bbFlag,
  bdFlag: bdFlag,
  bgFlag: bgFlag,
  bhFlag: bhFlag,
  biFlag: biFlag,
  bmFlag: bmFlag,
  bnFlag: bnFlag,
  boFlag: boFlag,
  brFlag: brFlag,
  bsFlag: bsFlag,
  btFlag: btFlag,
  bwFlag: bwFlag,
  byFlag: byFlag,
  bzFlag: bzFlag,
  caFlag: caFlag,
  cdFlag: cdFlag,
  cfFlag: cfFlag,
  ciFlag: ciFlag,
  clFlag: clFlag,
  cnFlag: cnFlag,
  coFlag: coFlag,
  crFlag: crFlag,
  cuFlag: cuFlag,
  cvFlag: cvFlag,
  czFlag: czFlag,
  djFlag: djFlag,
  dkFlag: dkFlag,
  dmFlag: dmFlag,
  doFlag: doFlag,
  dzFlag: dzFlag,
  egFlag: egFlag,
  ehFlag: ehFlag,
  erFlag: erFlag,
  etFlag: etFlag,
  europeanUnFlag: europeanUnFlag,
  fjFlag: fjFlag,
  fkFlag: fkFlag,
  gbFlag: gbFlag,
  geFlag: geFlag,
  ghFlag: ghFlag,
  giFlag: giFlag,
  gmFlag: gmFlag,
  gnFlag: gnFlag,
  gpFlag: gpFlag,
  gtFlag: gtFlag,
  gyFlag: gyFlag,
  hkFlag: hkFlag,
  hnFlag: hnFlag,
  hrFlag: hrFlag,
  htFlag: htFlag,
  huFlag: huFlag,
  idFlag: idFlag,
  ilFlag: ilFlag,
  imFlag: imFlag,
  iqFlag: iqFlag,
  irFlag: irFlag,
  isFlag: isFlag,
  jeFlag: jeFlag,
  jmFlag: jmFlag,
  joFlag: joFlag,
  jpFlag: jpFlag,
  keFlag: keFlag,
  kgFlag: kgFlag,
  khFlag: khFlag,
  kmFlag: kmFlag,
  kpFlag: kpFlag,
  krFlag: krFlag,
  kwFlag: kwFlag,
  kyFlag: kyFlag,
  kzFlag: kzFlag,
  laFlag: laFlag,
  lbFlag: lbFlag,
  liFlag: liFlag,
  lkFlag: lkFlag,
  lrFlag: lrFlag,
  lsFlag: lsFlag,
  ltFlag: ltFlag,
  lvFlag: lvFlag,
  lyFlag: lyFlag,
  mdFlag: mdFlag,
  mgFlag: mgFlag,
  mkFlag: mkFlag,
  mmFlag: mmFlag,
  mnFlag: mnFlag,
  moFlag: moFlag,
  mrFlag: mrFlag,
  muFlag: muFlag,
  mvFlag: mvFlag,
  mwFlag: mwFlag,
  mxFlag: mxFlag,
  myFlag: myFlag,
  mzFlag: mzFlag,
  naFlag: naFlag,
  ngFlag: ngFlag,
  niFlag: niFlag,
  noFlag: noFlag,
  npFlag: npFlag,
  nzFlag: nzFlag,
  omFlag: omFlag,
  paFlag: paFlag,
  peFlag: peFlag,
  pgFlag: pgFlag,
  phFlag: phFlag,
  pkFlag: pkFlag,
  plFlag: plFlag,
  pyFlag: pyFlag,
  qaFlag: qaFlag,
  roFlag: roFlag,
  rsFlag: rsFlag,
  ruFlag: ruFlag,
  rwFlag: rwFlag,
  saFlag: saFlag,
  sbFlag: sbFlag,
  scFlag: scFlag,
  sdFlag: sdFlag,
  seFlag: seFlag,
  sgFlag: sgFlag,
  slFlag: slFlag,
  soFlag: soFlag,
  srFlag: srFlag,
  stFlag: stFlag,
  svFlag: svFlag,
  sxFlag: sxFlag,
  syFlag: syFlag,
  szFlag: szFlag,
  thFlag: thFlag,
  tjFlag: tjFlag,
  tmFlag: tmFlag,
  tnFlag: tnFlag,
  toFlag: toFlag,
  trFlag: trFlag,
  ttFlag: ttFlag,
  twFlag: twFlag,
  tzFlag: tzFlag,
  uaFlag: uaFlag,
  ugFlag: ugFlag,
  usFlag: usFlag,
  uyFlag: uyFlag,
  uzFlag: uzFlag,
  veFlag: veFlag,
  vnFlag: vnFlag,
  vuFlag: vuFlag,
  wfFlag: wfFlag,
  wsFlag: wsFlag,
  yeFlag: yeFlag,
  zaFlag: zaFlag,
  zmFlag: zmFlag,
  zwFlag: zwFlag
};
